module.exports = __webpack_public_path__ + "img/aplicativo-destaque.d7da2606.png";